export default __webpack_public_path__ + "static/media/Gilbert.a7294ad4.png";